// pages/admin/AdminLogin.js
import React, { useState } from 'react';
import { useAdmin } from '../../contexts/AdminContext';

const AdminLogin = () => {
  const { login, loading, error } = useAdmin();
  const [formData, setFormData] = useState({
    email: '',
    password: ''
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!formData.email || !formData.password) {
      return;
    }

    await login(formData.email, formData.password);
  };

  return (
    <div className="admin-login-container">
      <div className="admin-login-form">
        <div className="admin-logo-container">
          <div className="admin-logo-placeholder">
            <i className="fas fa-shield-alt"></i>
          </div>
          <h1>PhenixLoc</h1>
          <p>Admin Panel</p>
        </div>
        
        <form onSubmit={handleSubmit}>
          <div className="admin-form-group">
            <label htmlFor="email">Email</label>
            <input
              type="email"
              id="email"
              name="email"
              value={formData.email}
              onChange={handleInputChange}
              placeholder="Enter your email"
              required
              disabled={loading}
            />
          </div>
          
          <div className="admin-form-group">
            <label htmlFor="password">Password</label>
            <input
              type="password"
              id="password"
              name="password"
              value={formData.password}
              onChange={handleInputChange}
              placeholder="Enter your password"
              required
              disabled={loading}
            />
          </div>
          
          {error && (
            <div className="admin-error-message">
              {error}
            </div>
          )}
          
          <button 
            type="submit" 
            className="admin-btn admin-btn-primary"
            disabled={loading}
          >
            {loading ? (
              <>
                <i className="fas fa-spinner fa-spin"></i>
                Logging in...
              </>
            ) : (
              'Login'
            )}
          </button>
        </form>
        
        <div className="admin-login-footer">
          <p>Secure Digital Asset Management</p>
        </div>
      </div>
    </div>
  );
};

export default AdminLogin;